<nz-spin [nzSpinning]="loading" [nzTip]="loadingMsg">
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    nz-form
    [nzLayout]="'vertical'"
  >
    <nz-card nzTitle="Venue Information" class="section-card">
      <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzRequired>Venue Name</nz-form-label>
            <nz-form-control nzErrorTip="This field is required">
              <input
                nz-input
                formControlName="venue_name"
                name="venue_name"
                placeholder="Venue name"
              />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzRequired>Venue Type</nz-form-label>
            <nz-form-control nzErrorTip="This field is required">
              <nz-select
                formControlName="venue_type"
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select venue type"
              >
                <nz-option
                  *ngFor="let type of venueTypeList"
                  [nzValue]="type.id"
                  [nzLabel]="type.name"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <!-- <nz-form-label nzRequired>Group/Brand</nz-form-label> -->
            <!-- <nz-form-label nzRequired>Brand</nz-form-label> -->
            <nz-form-label nzRequired>Vendor</nz-form-label>


            <nz-form-control nzErrorTip="This field is required">
              <nz-select formControlName="brand" nzShowSearch nzAllowClear nzPlaceHolder="Select brand">
                <nz-option
                  *ngFor="let vendor of vendorList"
                  [nzValue]="vendor.id"
                  [nzLabel]="vendor.name"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label [nzFor]="'star_rating'" [nzRequired]="true"
              >Star Rating</nz-form-label
            >
            <nz-form-control [nzErrorTip]="starRatingErrorTpl">
              <nz-rate
                formControlName="star_rating"
                [nzCount]="5"
                [nzAllowHalf]="true"
              ></nz-rate>
              <ng-template #starRatingErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Star rating is required.
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzRequired>City</nz-form-label>
            <nz-form-control nzErrorTip="This field is required">
              <nz-select
                nzShowSearch
                nzAllowClear
                formControlName="city"
                id="city"
                nzServerSearch
                (nzOnSearch)="onSearchCity($event)"
                nzPlaceHolder="City"
              >
                <nz-option
                  *ngFor="let city of cityList"
                  [nzValue]="city.id"
                  [nzLabel]="
                    city.name +
                    ', ' +
                    (city.state_name || '') +
                    ', ' +
                    (city.country_name || '')
                  "
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzRequired>Preference</nz-form-label>
            <nz-form-control nzErrorTip="This field is required">
              <nz-select
                nzShowSearch
                nzAllowClear
                formControlName="preference"
                id="preference"
                nzPlaceHolder="Preference"
              >
                <nz-option
                  *ngFor="let preference of preferanceArr"
                  [nzValue]="preference.id"
                  [nzLabel]="preference.name"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <!-- <nz-form-label>Neighborhood/Proximity</nz-form-label> -->
            <nz-form-label>Neighborhood</nz-form-label>

            <nz-form-control>
              <input
                nz-input
                formControlName="neighborhood"
                name="neighborhood"
                placeholder="Neighborhood/Proximity"
              />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzRequired>Address</nz-form-label>
            <nz-form-control nzErrorTip="This field is required">
              <input
                nz-input
                formControlName="address"
                name="address"
                placeholder="Address"
              />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label>Website</nz-form-label>
            <nz-form-control nzErrorTip="Please provide correct URL">
              <input
                nz-input
                formControlName="website"
                name="website"
                placeholder="Website URL"
              />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
      <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label>About</nz-form-label>
            <nz-form-control>
              <textarea
                nz-input
                formControlName="about"
                name="about"
                placeholder="About"
                rows="4"
              ></textarea>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>
    </nz-card>
    <div style="margin-top: 24px">
      <button nz-button nzType="primary" [disabled]="loading" htmlType="submit">
        Save Venue
      </button>
    </div>
  </form>
</nz-spin>
